export const GlobalDefault = Object.freeze({ key: 'global', text: 'Global', value: 'global' });